import ClientTasksProvider from "context/admin/client_tasks";
import TasksTable from "page_components/admin/clients/TasksTable";

const ClientTasks = () => (
  <ClientTasksProvider>
    <TasksTable />
  </ClientTasksProvider>
);

export default ClientTasks;
